var path = 'src/app/components/common/validator/validator.template.html';
var html = "<span class=\"hidden-element\" ng-if=\"!$ctrl.condition\">\n  <input class=\"hidden-element\" disabled ng-required=\"true\" ng-model=\"__nonExistingValue\"/>\n</span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;